const htmlHeadingNodeToLatexPrinter = (node, printChildren) => {
  var _a;
  if (!node.children) {
    return "";
  }
  const level = Number(((_a = node.tagName.match(/^h(\d)$/)) == null ? void 0 : _a[1]) ?? "6");
  const children = printChildren(node.children).join("");
  switch (level) {
    case 1:
      return `\\section{${children}}
`;
    case 2:
      return `\\subsection{${children}}
`;
    case 3:
      return `\\subsubsection{${children}}
`;
    case 4:
      return `\\paragraph{${children}}
`;
    case 5:
      return `\\subparagraph{${children}}
`;
    case 6:
    default:
      return `\\subsubparagraph{${children}}
`;
  }
};

export { htmlHeadingNodeToLatexPrinter };
//# sourceMappingURL=html.headings.js.map
